<p-editor [ngModel]="message" (ngModelChange)="messageChange.emit($event)">
  <p-header>
    <span class="ql-formats">
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <button class="ql-strike"></button>
    </span>
    <span class="ql-formats">
      <button class="ql-list" value="ordered"></button>
      <button class="ql-list" value="bullet"></button>
    </span>
    <span class="ql-formats">
      <select class="ql-header" style="width: 18ex;">
        <option value="3">Überschrift</option>
        <option value="4">Unterüberschrift</option>
        <option selected>Text</option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-link"></button>
    </span>
  </p-header>
</p-editor>
